import React, { useState, useEffect } from "react";
import "./App.css";
import Swal from "sweetalert2";
import ProductMenu from "./components/ProductMenu";
import { login } from "./components/authService";
import { getSessionData, getCategories } from "./components/ApiProducts";
import { MessageAlertTokenExpire } from "./customStyles";
import { getHeaderImage } from "./themeConfig";

const isDevMode = process.env.REACT_APP_DEV_MODE === "true";
const DEV_SEDE_ID = process.env.REACT_APP_SEDE_ID || "00301";

const App = () => {
  const [showCatalog, setShowCatalog] = useState(false);
  const [categories, setCategories] = useState([]);
  const [sedeId, setSedeId] = useState("");
  const [sessionId, setSessionId] = useState("");
  const [sessionData, setSessionData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const urlParams = new URLSearchParams(window.location.search);
  const sessionIdFromUrl = urlParams.get("session_id");

  useEffect(() => {
    const initApp = async () => {
      try {
        // ── Dev mode: skip auth, use default sede ──
        if (isDevMode) {
          console.log("DEV MODE: Usando sede_id por defecto:", DEV_SEDE_ID);
          setSedeId(DEV_SEDE_ID);
          setSessionId("dev-session");

          // Login to Asertis API (still needed for product fetching)
          await login();

          const categoriesData = await getCategories(DEV_SEDE_ID);
          setCategories(categoriesData);
          setShowCatalog(true);
          setIsLoading(false);
          return;
        }

        // ── Production mode ──
        if (!sessionIdFromUrl) {
          MessageAlertTokenExpire();
          setIsLoading(false);
          return;
        }

        setSessionId(sessionIdFromUrl);

        // 1. Login to Asertis API
        await login();

        // 2. Get session data (sede_id, client info, etc.)
        const session = await getSessionData(sessionIdFromUrl);
        if (!session || !session.sede) {
          MessageAlertTokenExpire();
          setIsLoading(false);
          return;
        }

        setSessionData(session);
        const currentSedeId = session.sede.sede_id;
        setSedeId(currentSedeId);
        console.log("Sede ID:", currentSedeId, "- Sede:", session.sede.sede);

        // 3. Load categories for this sede
        const categoriesData = await getCategories(currentSedeId);
        if (!categoriesData || categoriesData.length === 0) {
          Swal.fire({
            icon: "warning",
            title: "Sin categorías disponibles",
            text: "No se encontraron categorías para esta sede.",
            confirmButtonColor: "#e63946",
          });
          setIsLoading(false);
          return;
        }
        setCategories(categoriesData);
        setShowCatalog(true);
        setIsLoading(false);
      } catch (error) {
        console.error("Error al inicializar la aplicación:", error);
        Swal.fire({
          icon: "error",
          title: "Error de conexión",
          text: "No se pudo conectar con el servidor. Intente nuevamente.",
          confirmButtonColor: "#e63946",
        });
        setIsLoading(false);
      }
    };

    initApp();
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <div className="logo-container">
          <img src={getHeaderImage()} alt="Logo" />
        </div>
      </header>
      <main className="product-container">
        {isLoading ? (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Cargando catálogo...</p>
          </div>
        ) : showCatalog ? (
          <ProductMenu
            categories={categories}
            sedeId={sedeId}
            sessionId={sessionId}
            sessionData={sessionData}
          />
        ) : null}
      </main>
    </div>
  );
};

export default App;